<script lang="ts">
	type Embedding = {
		page?: string;
		container?: string;
		showChatbot?: boolean;
	};

	let {
		propertyId,
		communityId,
		embedding
	}: {
		propertyId: string;
		communityId: string;
		embedding?: Embedding;
	} = $props();

	const initArgs = embedding
		? `'${propertyId}', 'community', '${communityId}', { embedding: ${JSON.stringify(embedding)} }`
		: `'${propertyId}', 'community', '${communityId}'`;

	const TAG = "scr" + "ipt";
	const loaderTag = `<${TAG} src="https://doorway.knck.io/latest/doorway.min.js"></${TAG}>`;
	const initTag = `<${TAG}>window.knockDoorway.init(${initArgs});</${TAG}>`;
</script>

<svelte:head>
	{@html loaderTag}
	{@html initTag}
</svelte:head>

{#if embedding?.container}
	<div id={embedding.container}></div>
{/if}
